import { RenderWhen } from "../../../../common/infrastructure/components/RenderWhen";
import { MessageStatus } from "../emailLogs/models/emailLogModel";
import { StatusChip } from "./StatusChip";
import styles from "./CommunicationLogDialogMeta.module.scss";

interface ICommunicationLogDialogMetaProps {
  receiver?: string;
  status?: MessageStatus;
  errorMessage?: string | null;
}

/** The top of an email, SMS or notification log dialog: who it went to, its status, any error. */
export const CommunicationLogDialogMeta = ({
  receiver,
  status,
  errorMessage,
}: ICommunicationLogDialogMetaProps) => (
  <>
    <div className={styles.meta}>
      <span>{receiver}</span>
      {status !== undefined && <StatusChip status={status} />}
    </div>

    <RenderWhen condition={!!errorMessage}>
      <div className={styles.error}>{errorMessage}</div>
    </RenderWhen>
  </>
);
